"use client";

import {useTranslation} from "react-i18next";
import {cn} from "@/lib/utils";
import ToggleChevron from "./ToggleChevron";
import {type LineExpansion} from "./types";

type StepOutputProps = Readonly<{
   outputLabel: string;
   failed: boolean;
   visibleLines: {key: string; line: string}[];
   expansion: LineExpansion;
}>;

export default function StepOutput({
   outputLabel,
   failed,
   visibleLines,
   expansion,
}: StepOutputProps) {
   const {t} = useTranslation("ask");
   const {hiddenCount, showAll, onToggleShowAll} = expansion;

   return (
      <div
         className={cn(
            "border-l-2 py-0.5 pl-2.5 font-mono text-xs leading-5",
            failed ? "border-destructive/40 text-destructive" : "border-green-500/40 text-500"
         )}
      >
         <div className="mb-0.5 font-sans text-[10px] font-medium uppercase tracking-wide text-400">
            {outputLabel}
         </div>
         {visibleLines.map(({key, line}) => (
            <div key={key} className="whitespace-pre-wrap break-words">
               {line || " "}
            </div>
         ))}
         {hiddenCount > 0 && (
            <button
               type="button"
               onClick={onToggleShowAll}
               className="mt-0.5 flex items-center gap-1.5 text-400 transition-colors hover:text-600"
            >
               <ToggleChevron expanded={showAll} />
               {showAll ? t("tools.labels.showLess") : t("tools.labels.moreLines", {count: hiddenCount})}
            </button>
         )}
      </div>
   );
}
